<template>

	<div>

		<label v-html="label" />
		<p class="info tags" v-html="theDescription" />
		<div class="current-tags">
			<span 
				class="disc green"
				v-for="(tagName, tagIndex) in tags" 
				:key="'tag-'+tagIndex"
			>
				{{tagName}}
			</span> 
			<span class="disc add-tag-btn" v-html="tags.length>0?'Add/Edit Tags':'Add Tags'" @click="showTagger=true" />
		</div>

		<Tagger 
			v-if="showTagger" 
			:settings="taggerSettings"
			@close-tagger="closeTagger"
			:lowerCaseTags="false"
		/>

	</div>

</template>

<script>
import general from './../utils/general'
import { mapState } from 'vuex'
import Tagger from './Tagger.vue'
export default {
  name: 'TagsPreview',
  props: {
  	label: {
  		type: String,
  		default: 'Tags'
  	},
  	tagName: {
  		type: String,
  		default: 'Tag'
  	},
  	taggerTitle: {
  		type: String,
  		default: 'Add Tags'
  	},
  	description: {
  		type: String,
  		default: ''
  	},
  	tags: {
  		type: Array,
  		default: function () { return [] }
  	},
  	availableTags: {
  		type: Array,
  		default: function () { return [] }
  	},
  	buttonText: {
  		type: String,
  		default: "Update Tags"
  	}
  },
  components: {
		Tagger
	},
  data() {
		return {
		  showTagger: false,
		  theTags: []
		}
  },
  methods: {
		closeTagger (info) {

			this.showTagger = false;

			general.modalClose();

			if ( typeof info !== 'undefined' && typeof info.tags !== 'undefined' ) this.theTags = info.tags;

			this.$emit( 'save', this.theTags );

		}
  },
  computed: {
  	...mapState('general',['tagsDescription']),
  	taggerSettings () {

  		return {
  			tags: this.tags, 
			returnOnly: true, 
			tagName: this.tagName,
			title: this.taggerTitle, 
			availableTags: this.availableTags,
			buttonText: this.buttonText
  		}

  	},
  	theDescription() {
  		
  		return this.description !== '' ? this.description : this.tagsDescription;

  	}
  },
  created () {
  	this.theTags = this.tags;
  }
}
</script>
<style lang="less" scoped>
@import './../assets/css/less/_settings.less';
p {
	padding: 0;
	margin: 0 0 5px;
	font-size: 12px;
	color: @formDefaultColour;
}
.current-tags {

	.add-tag-btn {

		cursor: pointer;
		background-color: @formDefaultColour;

		&:hover {

			background-color: #000;

		}

	}

}
</style>